import React, { Component } from 'react';
import StaticCard from './StaticCard.js';
import AnimatedCard from './AnimatedCard.js';
import './style/FlipUnitContainer.sass';
export default class FlipUnitContainer extends React.Component {
  render() {
    const { digit, shuffle, unit, down, interval } = this.props;

    let now = digit;
    let before = down ? digit + 1 : digit - 1;
    // to prevent a negative value
    if (unit !== 'hours') {
      before = before === -1 ? 59 : before;
    } else {
      before = before === -1 ? 23 : before;
    }

    // add zero
    if (now < 10) now = `0${now}`;
    if (before < 10) before = `0${before}`;

    // shuffle digits
    const digit1 = shuffle ? before : now;
    const digit2 = !shuffle ? before : now;

    // shuffle animations
    let animation1, animation2;
    if (interval <= 1100) {
      animation1 = shuffle ? ' fold foldDead' : 'unfold unfoldDead';
      animation2 = !shuffle ? 'fold foldDead' : 'unfold unfoldDead';
    }
    if (interval <= 4000) {
      animation1 = shuffle ? ' fold foldSlowest' : 'unfold unfoldSlowest';
      animation2 = !shuffle ? 'fold foldSlowest' : 'unfold unfoldSlowest';
    } else if (interval <= 7000) {
      animation1 = shuffle ? 'fold foldSlower' : 'unfold unfoldSlower';
      animation2 = !shuffle ? 'fold  foldSlower' : 'unfold unfoldSlower';
    } else {
      animation1 = shuffle ? 'fold' : 'unfold';
      animation2 = !shuffle ? 'fold' : 'unfold';
    }

    return (
      <div className={'flipUnitContainer'}>
        <StaticCard position={'upperCard'} digit={now} />
        <StaticCard position={'lowerCard'} digit={before} />
        <AnimatedCard position={'first'} digit={digit1} animation={animation1} />
        <AnimatedCard position={'second'} digit={digit2} animation={animation2} />
        <label className="flipUnitContinerLabel">{unit || 'days'}</label>
      </div>
    );
  }
}
